var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('h2',[_vm._v("Anmeldung im Forum…")]),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}]})])}
var staticRenderFns = []

export { render, staticRenderFns }